/*
  Try at home pilot (2026-10-19; one-click / one-tick journey, Jakob same day).

  Product page (snippets/nv-try-pdp.liquid): the button opens the facts and
  "Add to try at home", which adds the selected size and opens the cart.
  Once this frame is added the button says "Added to try at home" (opens the
  cart) with a Remove link; with 3 frames it says "Try at home is full".
  No "box" anywhere (Jakob 2026-10-20: we just ship frames). Each line
  carries _Try at home = "<version>".

  Cart (snippets/nv-try-cart.liquid): the one terms tick (or the reason
  checkout must wait) is moved from its <template> to right above the
  checkout button ([data-nv-try-foot]). The button is greyed until the
  terms are ticked; the tick saves the cart attribute "Try at home terms" =
  "<version> accepted <time>", cleared again if the last try-on frame is
  removed. A submit guard in the capture phase backs this up.

  ?nvtry=1 shows a switched-off block for checking (kept for the tab).
*/
(function () {
  'use strict';

  var ATTR = 'Try at home terms';
  var STAMP = '_Try at home terms';
  var stamping = 0;
  var MAX = 3;
  var preview = false;
  try {
    if (/[?&]nvtry=1/.test(location.search)) sessionStorage.setItem('nvtry', '1');
    preview = sessionStorage.getItem('nvtry') === '1';
  } catch (e) { preview = /[?&]nvtry=1/.test(location.search); }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function tryLines(cart) { return cart.items.filter(function (i) { return i.product_type === 'Try-on'; }); }

  // Take one try-on line out, then let the drawer and the product page redraw
  function removeLine(key) {
    return post('/cart/change.js', { id: key, quantity: 0 }).then(function (c) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
      return c;
    });
  }

  /* ---------- Product page ---------- */
  function initPdp(box) {
    if (preview && box.classList.contains('nv-try--off')) {
      box.classList.remove('nv-try--off');
      document.querySelectorAll('[data-nv-try-fallback]').forEach(function (n) { n.classList.add('nv-try-gone'); });
    }
    var variants = [];
    try { variants = JSON.parse(box.dataset.variants || '[]'); } catch (e) {}
    var open = box.querySelector('[data-nv-try-open]');
    var cta = box.querySelector('[data-nv-try-cta]');
    var sub = box.querySelector('[data-nv-try-sub]');
    var panel = box.querySelector('[data-nv-try-panel]');
    var add = box.querySelector('[data-nv-try-add]');
    var note = box.querySelector('[data-nv-try-note]');
    var remove = box.querySelector('[data-nv-try-remove]');
    var help = box.querySelector('[data-nv-try-help]');
    var NOTE = note.textContent;
    var current = box.dataset.current || '';
    // Whether the size selected on the page can be bought at all
    var frameAvailable = box.dataset.currentAvailable !== 'false';
    var cart = null;
    var busy = false;
    var ONE = ['One size', 'Default Title'];

    // The try-on variant for the size selected on the page. A one-size try-on
    // frame only stands in for a one-size frame (or Bilbao's reader strengths),
    // never for a size it isn't, e.g. Paris Large for Paris Medium.
    function match(title) {
      for (var i = 0; i < variants.length; i++) {
        var t = variants[i].title;
        if (t === title || title.split(' / ').indexOf(t) !== -1) return variants[i];
      }
      if (variants.length === 1 && ONE.indexOf(variants[0].title) !== -1 &&
          !/^(small|medium|large)\b/i.test(title)) return variants[0];
      return null;
    }

    // One place decides what the buttons say and do
    function render() {
      var v = match(current);
      var lines = cart ? tryLines(cart) : [];
      var count = lines.reduce(function (n, i) { return n + i.quantity; }, 0);
      var inBox = !!(v && lines.some(function (i) { return i.variant_id === v.id; }));
      var view = inBox || (count >= MAX);
      // This size can be tried: a try-on frame in stock AND the frame itself in stock
      var ok = !!(v && v.available && frameAvailable);
      var unavailable = !view && !ok;
      open.dataset.mode = view ? 'view' : 'open';
      open.disabled = unavailable;
      if (inBox) {
        cta.textContent = 'Added to try at home';
        sub.textContent = count + ' of 3 frames · View cart';
      } else if (count >= MAX) {
        cta.textContent = 'Try at home is full';
        sub.textContent = '3 of 3 frames · View cart';
      } else if (unavailable) {
        cta.textContent = 'Try frames at home, free';
        // No try-on stock in any size: "right now"; otherwise this size only
        var anyStock = variants.some(function (x) { return x.available; });
        sub.textContent = anyStock ? 'Not available to try at home in this size' : 'Not available to try at home right now';
      } else {
        cta.textContent = 'Try frames at home, free';
        sub.textContent = count > 0 ? count + ' of 3 frames added' : 'Up to 3 frames for 7 days';
      }
      remove.hidden = !inBox;
      if (help) help.hidden = !unavailable;
      remove.disabled = busy;
      if (view || unavailable) { panel.hidden = true; open.setAttribute('aria-expanded', 'false'); }
      add.disabled = busy || !ok;
      add.textContent = busy ? 'Adding…' : 'Add to try at home';
      note.textContent = NOTE;
    }

    function refreshCart() {
      return getCart().then(function (c) { cart = c; render(); }).catch(function () { render(); });
    }

    open.addEventListener('click', function () {
      if (open.dataset.mode === 'view') {
        document.dispatchEvent(new CustomEvent('cart:open'));
        return;
      }
      var show = panel.hidden;
      panel.hidden = !show;
      open.setAttribute('aria-expanded', show ? 'true' : 'false');
    });

    add.addEventListener('click', function () {
      var v = match(current);
      if (!v || !v.available || !frameAvailable || busy) return;
      busy = true; render();
      var props = { '_Try at home': box.dataset.version || 'v1' };
      // Terms already accepted in this cart: the new frame carries it too
      if (cart && cart.attributes && cart.attributes[ATTR]) props[STAMP] = cart.attributes[ATTR];
      post('/cart/add.js', { items: [{ id: v.id, quantity: 1, properties: props }] })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function () { note.textContent = 'The frame couldn’t be added. Please try again'; })
        .then(function () { busy = false; return refreshCart(); });
    });

    remove.addEventListener('click', function () {
      var v = match(current);
      var line = v && cart ? tryLines(cart).filter(function (i) { return i.variant_id === v.id; })[0] : null;
      if (!line || busy) return;
      busy = true; render();
      removeLine(line.key)
        .then(function (c) { cart = c; })
        .catch(function () {})
        .then(function () { busy = false; return refreshCart(); });
    });

    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && v.title) { current = v.title; frameAvailable = v.available !== false; render(); }
    });

    /* The Nividas size buttons (nv-pdp-size) set the product form's variant
       id and fire "change" on it, but never the theme's variant:change, and
       they pick their own size after load (Paris showed Large while the
       button still meant Medium, 2026-10-21). So follow the form's id. */
    var frameVariants = [];
    try { frameVariants = JSON.parse(box.dataset.frameVariants || '[]'); } catch (e) {}
    function fromId(id) {
      var fv = frameVariants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!fv || (fv.title === current && fv.available === frameAvailable)) return;
      current = fv.title; frameAvailable = fv.available; render();
    }
    function formIdEl() {
      var els = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
      for (var i = 0; i < els.length; i++) { if (frameVariants.some(function (x) { return String(x.id) === String(els[i].value); })) return els[i]; }
      return null;
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'id' && t.closest && t.closest('form[action*="/cart/add"]')) fromId(t.value);
    }, true);
    // The size the page settled on after load
    [0, 400, 1500].forEach(function (ms) { setTimeout(function () { var el = formIdEl(); if (el) fromId(el.value); }, ms); });
    // Removing a frame in the cart puts the button back
    document.addEventListener('cart:updated', function (e) {
      if (e.detail && e.detail.cart) { cart = e.detail.cart; render(); } else refreshCart();
    });

    render();
    refreshCart();
  }

  /* ---------- Cart ---------- */
  function syncFoot(form) {
    var slot = form.querySelector('[data-nv-try-foot]');
    var block = form.querySelector('[data-nv-try-cart]');
    var checkout = form.querySelector('.cart__checkout');
    if (!slot) return;
    if (!block) {
      // The last try-on frame just left the cart: drop the terms acceptance
      // so it doesn't ride along on an order without try-on frames.
      if (slot.firstElementChild) {
        getCart().then(function (c) {
          if (!tryLines(c).length && c.attributes && c.attributes[ATTR]) { var clear = {}; clear[ATTR] = ''; return post('/cart/update.js', { attributes: clear }); }
        }).catch(function () {});
      }
      slot.innerHTML = '';
      if (checkout) { checkout.classList.remove('nv-try-locked'); checkout.removeAttribute('aria-disabled'); }
      return;
    }
    var tpl = block.querySelector('[data-nv-try-foot-tpl]');
    if (tpl) {
      var fresh = tpl.content.cloneNode(true).firstElementChild;
      var old = slot.firstElementChild;
      // Keep a tick the customer just made while the cart re-renders
      if (old && fresh) {
        var oldCb = old.querySelector('[data-nv-try-cart-accept]');
        var newCb = fresh.querySelector('[data-nv-try-cart-accept]');
        if (oldCb && newCb && oldCb.checked) newCb.checked = true;
      }
      slot.innerHTML = '';
      if (fresh) slot.appendChild(fresh);
    }
    lockCheckout(form);
  }

  function isOk(form) {
    var block = form.querySelector('[data-nv-try-cart]');
    if (!block) return true;
    var cb = form.querySelector('[data-nv-try-foot] [data-nv-try-cart-accept]');
    // Not while the acceptance is still being saved on the lines
    return block.dataset.state === 'ok' && !!(cb && cb.checked) && stamping === 0;
  }

  function lockCheckout(form) {
    var checkout = form.querySelector('.cart__checkout');
    if (!checkout) return;
    var ok = isOk(form);
    checkout.classList.toggle('nv-try-locked', !ok);
    if (ok) checkout.removeAttribute('aria-disabled'); else checkout.setAttribute('aria-disabled', 'true');
  }

  function watch(form) {
    var products = form.querySelector('[data-products]');
    syncFoot(form);
    if (products && window.MutationObserver) {
      new MutationObserver(function () { syncFoot(form); }).observe(products, { childList: true, subtree: true });
    }
  }

  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-nv-try-cart-accept]');
    if (!cb) return;
    var form = cb.closest('form');
    var block = form && form.querySelector('[data-nv-try-cart]');
    if (form) lockCheckout(form);
    var attrs = {};
    var value = cb.checked ? ((block && block.dataset.version) || 'v1') + ' accepted ' + new Date().toISOString() : '';
    attrs[ATTR] = value;
    stamping++;
    if (form) lockCheckout(form);
    post('/cart/update.js', { attributes: attrs })
      .then(function () { return stampLines(value); })
      .catch(function () { cb.checked = false; })
      .then(function () { stamping--; if (form) lockCheckout(form); });
  });

  /* The acceptance also goes on every try-on line (2026-10-21): the Fortnox
     app rewrites the order's note attributes a minute after checkout, which
     wiped "Try at home terms" from the first real order. Line properties are
     left alone. Changing a line's properties gives it a new key, so try-on
     lines are removed by variant id, never by key. */
  function stampLines(value) {
    return getCart().then(function (c) {
      var todo = tryLines(c).filter(function (i) { return ((i.properties || {})[STAMP] || '') !== value; });
      var chain = Promise.resolve();
      todo.forEach(function (i) {
        var props = {};
        Object.keys(i.properties || {}).forEach(function (k) { if (k !== STAMP) props[k] = i.properties[k]; });
        if (value) props[STAMP] = value;
        chain = chain.then(function () { return post('/cart/change.js', { id: i.key, quantity: i.quantity, properties: props }); });
      });
      return chain.then(function () { if (todo.length) document.dispatchEvent(new CustomEvent('cart:build')); });
    });
  }

  // Remove in the drawer: Impulse hides Remove there (its − button removes),
  // and try-on lines have no − button. Stay in the drawer instead of
  // following the link to /cart. On the cart page the link works as is.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-nv-try-remove-line] a');
    if (!a || !a.closest('#CartDrawerForm')) return;
    e.preventDefault();
    e.stopPropagation();
    var key = a.closest('[data-nv-try-remove-line]').getAttribute('data-nv-try-remove-line');
    a.setAttribute('aria-disabled', 'true');
    removeLine(key).catch(function () { location.href = a.href; });
  }, true);

  // Capture phase: runs before the theme's own submit handler on the form.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector || !form.querySelector('[data-nv-try-cart]')) return;
    if (isOk(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('.cart__checkout');
    if (btn) btn.classList.remove('btn--loading');
    var foot = form.querySelector('[data-nv-try-foot] .nv-try-foot');
    if (foot) {
      foot.classList.add('nv-try-foot--attn');
      setTimeout(function () { foot.classList.remove('nv-try-foot--attn'); }, 1200);
    }
  }, true);

  function boot() {
    var box = document.querySelector('[data-nv-try]');
    if (box) initPdp(box);
    document.querySelectorAll('#CartDrawerForm, #CartPageForm').forEach(watch);
    // An acceptance left over in a cart with no try-on frames (e.g. the last
    // frame removed on /cart, which reloads the page): drop it. Decided from
    // the cart itself, never from the markup — the drawer fills in after load.
    getCart().then(function (c) {
      if (c.attributes && c.attributes[ATTR] && !tryLines(c).length) { var clear = {}; clear[ATTR] = ''; return post('/cart/update.js', { attributes: clear }); }
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
